export default __webpack_public_path__ + "static/media/get-involved-1.388562da.png";